import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Axios instance with credentials enabled so the httpOnly `psg_token` cookie
 * is automatically sent on every request. We no longer read/write tokens
 * from JS-accessible storage — this eliminates the XSS token-theft vector.
 */
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
